import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAffiliateAttribution } from "../../utils/affiliate-attribution";

/** Capture ?ref= et ?recruit= sur toutes les pages commerciales. */
export function AffiliateRefCapture() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    captureAffiliateAttribution(search, pathname);
  }, [pathname, search]);

  return null;
}
